import * as React from 'react';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { FooterContainer } from './FooterContainer';

const TermsOfUseLink = (chunks: ReactNode) => (
  <FooterContainer.TermsOfUseLink>{chunks}</FooterContainer.TermsOfUseLink>
);
const PoliciesLink = (chunks: ReactNode) => (
  <FooterContainer.PoliciesLink>{chunks}</FooterContainer.PoliciesLink>
);

export const Terms = () => {
  const translate = useTranslations('participating.footer');
  return (
    <FooterContainer.TermsContainer>
      <FooterContainer.TermsText fontSize="75">
        {translate.rich('terms_of_use_message', {
          TermsOfUseLink,
          PoliciesLink,
        })}
      </FooterContainer.TermsText>
    </FooterContainer.TermsContainer>
  );
};
